import React from "react";
import { useState, useEffect } from 'react';
import './classes/ManageProducts.css';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const CourseMentors = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;

    // Product type "1" corresponds to Course in the product table.
    const COURSE_PRODUCT_TYPE = "1";

    const columns = [
        {
            field: 'productName',
            headerName: 'Course Name',
            headerClassName: 'product-name-header',
            flex: 3,
            sortable: false,
            filterable: false,
        },
        {
            field: 'productSku',
            headerName: 'Course SKU',
            headerClassName: 'product-sku-header',
            flex: 2,
            sortable: false,
            filterable: false,
        },
        {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate('/admin/course-mentors/edit/' + params.row.id)}
                    style={{ backgroundColor: "#2C99D2", textTransform: "none" }}
                >
                    Edit
                </Button>
            ),
        },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch(app_url + 'smwwcommerceproduct/getlist', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        page: paginationModel.page,
                        pageSize: paginationModel.pageSize,
                        sortModel: [],
                        filterModel: { items: [] },
                        formData: {
                            product_sku: '',
                            product_title: '',
                            product_type: COURSE_PRODUCT_TYPE,
                            relate_categories: '',
                            product_status: '1',
                        },
                    }),
                });
                const data = await response.json();
                setRows(data.data.rows);
                setRowCount(data.data.totalRowCount);
            } catch (error) {
                console.error('Error fetching courses:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [paginationModel, app_url]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="manage-products-main">
                    <Helmet><title>Course Mentors</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1>Course Mentors</h1>
                        <div className="manage-products-container">
                            <div className="manage-products-table" style={{ width: '100%' }}>
                                <DataGrid
                                    autoHeight={true}
                                    rows={rows}
                                    columns={columns}
                                    rowCount={rowCount}
                                    getRowHeight={() => 'auto'}
                                    paginationMode="server"
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    pageSizeOptions={[5, 10, 25, 50]}
                                    pageSize={50}
                                    getRowId={(row) => row.id}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};

export default CourseMentors;
